import { ReasonForPermissionModel } from '@/models/config'
import { ReasonForPermissionService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useReasonForPermission () {
  const reasons: Ref<ReasonForPermissionModel[]> = ref([])

  const getReasonsForPermission = async () => {
    reasons.value = await ReasonForPermissionService.getActivated()
  }
  getReasonsForPermission()

  const reasonForPermissionOp = computed(() => {
    return reasons.value.map(reason => {
      return {
        value: reason.id,
        text: reason.description
      }
    })
  })

  return { reasons, reasonForPermissionOp, getReasonsForPermission }
}
